import {
  StatementEditorV2ContentDataType,
  StatementEditorV2FieldDefinition,
} from '../types'
import { RenderCellV2 } from '../../DataTableV2/RenderCellV2'
import { DataTableV2StringColumnDataDisplay } from '../../DataTableV2/types'

const defaultStringDisplay: DataTableV2StringColumnDataDisplay = { type: 'string' }

export function ItemHeaderLayoutV2({
  headerFields,
  content,
}: {
  headerFields: StatementEditorV2FieldDefinition[]
  content: StatementEditorV2ContentDataType
}) {
  const componentFields = headerFields.filter(
    (f) => f.layout.dataDisplay && 'component' in f.layout.dataDisplay
  )
  const otherFields = headerFields.filter(
    (f) => !f.layout.dataDisplay || !('component' in f.layout.dataDisplay)
  )

  return (
    <div className="flex flex-wrap items-center gap-x-2">
      {componentFields.length > 0 && (
        <div className="flex flex-wrap items-center gap-x-2">
          {componentFields.map((field) => {
            const value = content[field.propertyId]
            if (value === undefined || value === null) return null
            return (
              <div key={field.propertyId} className="flex items-center">
                <RenderCellV2
                  dataDisplay={field.layout.dataDisplay!}
                  value={value}
                />
              </div>
            )
          })}
        </div>
      )}
      {componentFields.length > 0 && otherFields.length > 0 && (
        <div className="mx-1 h-4 w-px bg-gray-200" />
      )}
      {otherFields.length > 0 && (
        <div className="flex flex-wrap items-center gap-x-2">
          {otherFields.map((field) => {
            const value = content[field.propertyId]
            if (value === undefined || value === null) return null
            return (
              <div key={field.propertyId} className="flex items-center">
                <RenderCellV2
                  dataDisplay={field.layout.dataDisplay ?? defaultStringDisplay}
                  value={value}
                />
              </div>
            )
          })}
        </div>
      )}
    </div>
  )
}
